import React, { useEffect, useState } from "react";
import AlertField from "./AlertField";
import useAuth from "../Hooks/useAuth";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../css/datePicker.css";
import moment from "moment-timezone";

const Schedule = () => {
  const { auth } = useAuth();
  const axiosPrivate = useAxiosPrivate();

  const [doctor, setDoctor] = useState();
  const [alert, setAlert] = useState(null);
  const [schedule, setSchedule] = useState({});

  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const [activeId, setActiveId] = useState(
    auth?.user.roles === 1 ? auth?.user.id : null
  );

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  useEffect(() => {
    const fetchDoctor = async () => {
      try {
        const response = await axiosPrivate.get("user/doctor/");
        setDoctor(response?.data);
      } catch (err) {
        showAlert("Load Failed", "warning");
      }
    };

    //gets the list of doctor if user is admin or gets the schedule of logged in doctor
    if (auth?.user.roles === 0) {
      fetchDoctor();
    } else {
      fetchSchedule(auth?.user.id);
    }
  }, []);

  const fetchSchedule = async (id) => {
    //gets the schedule of doctor
    const response = await axiosPrivate.get(`user/doctor/schedule/${id}/`);
    setSchedule(response?.data);
    setDateRange([
      new Date(response.data.start_date),
      new Date(response.data.end_date),
    ]);
  };

  //filters data in table based on dropdown selection
  const onFilter = async (e) => {
    const selected = e.target.value;
    if (selected === "none") {
      //set schedule, date and active id to null
      setSchedule({});
      setDateRange([]);
      setActiveId(null);
    } else {
      try {
        fetchSchedule(selected);
        setActiveId(selected);
      } catch (error) {
        showAlert("Load Failed", "warning");
      }
    }
  };

  const onChange = (e) => {
    setSchedule({ ...schedule, [e.target.name]: e.target.value });
  };

  const onSave = async (e) => {
    e.preventDefault();
    const data = {
      doctor: schedule.doctor,
      start_time: schedule.start_time,
      end_time: schedule.end_time,
      start_date: moment(startDate).format("YYYY-MM-DD", "24hr"),
      end_date: moment(endDate).format("YYYY-MM-DD", "24hr"),
      duration: schedule.duration,
    };
    //validates selection of doctor
    if (!activeId) {
      showAlert("Select doctor.", "warning");
    }
    //validates date range selection
    else if (dateRange[0] === null || dateRange[1] === null) {
      showAlert("Select proper date range.", "warning");
    }
    //validates time selection; start time should be less than end time
    else if (data.start_time === null || data.end_time === null || data.start_time > data.end_time) {
      showAlert("Select proper time range.", "warning");
    } else {
      //updates the schedule
      try {
        await axiosPrivate.put(`user/doctor/schedule/${activeId}/`, data);
        showAlert("Schedule Updated.", "success");
      } catch (err) {
        showAlert("Failed", "warning");
      }
    }
  };

  return (
    <>
      <AlertField alert={alert} />
      <h2 className="text-center py-2">Edit Schedule</h2>
      <form>
        <div className="d-flex flex-column align-items-center">
          <div className="w-50">
            <table>
              <tbody>
                {auth?.user.roles === 0 && (
                  <tr>
                    <td className="w-50">
                      <h4 className="my-3">Choose Doctor</h4>
                    </td>
                    <td>
                      <select
                        name="filter"
                        className="w-100 p-1"
                        onClick={onFilter}
                      >
                        <option value="none" className="p-1">
                          Choose Doctor
                        </option>

                        {doctor?.map(
                          (doctor, i) =>
                            doctor?.user_detail.is_active && (
                              <option key={i} value={doctor?.user}>
                                {doctor?.user_detail.name}
                              </option>
                            )
                        )}
                      </select>
                    </td>
                  </tr>
                )}
                <tr>
                  <td className="w-50">
                    <h4 className="my-3">Choose Date</h4>
                  </td>
                  <td>
                    <DatePicker
                      selectsRange={true}
                      startDate={startDate}
                      endDate={endDate}
                      onChange={(update) => {
                        setDateRange(update);
                      }}
                      isClearable={true}
                      minDate={new Date()}
                      todayButton="Today"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <h4 className="my-3">Choose Time</h4>
                  </td>
                  <td>
                    <input
                      type="time"
                      name="start_time"
                      value={
                        schedule?.start_time
                          ? moment(schedule?.start_time, "HH:mm:ss").format(
                              "HH:mm"
                            )
                          : ""
                      }
                      onChange={onChange}
                    />
                    <label className="mx-2 my-0">--</label>
                    <input
                      type="time"
                      name="end_time"
                      value={
                        schedule?.end_time
                          ? moment(schedule?.end_time, "HH:mm:ss").format(
                              "HH:mm"
                            )
                          : ""
                      }
                      onChange={onChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <h4 className="my-3">Duration</h4>
                  </td>
                  <td>
                    <select
                      id="duration"
                      className="p-1"
                      name="duration"
                      onChange={onChange}
                      value={schedule?.duration ? schedule.duration : ""}
                    >
                      <option value="15">15 minutes</option>
                      <option value="30">30 minutes</option>
                      <option value="45">45 minutes</option>
                      <option value="60">60 minutes</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <button className="btn btn-primary my-2 px-4" onClick={onSave}>
              Save
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default Schedule;
